export const GOOD_FEEDBACK = "good_feedback";
export const IMPROVE_FEEDBACK = "improve_feedback";
